// TODO: remove eslint disable
/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/complex/Header";
import {
  Container,
  Row,
  Col,
  Card,
  CardTitle,
  CardBody
} from "components/simple";
import { crm } from "router/routes";
import { useDispatch, useSelector } from "react-redux";
import API from "api";
import { useForm } from "react-hook-form";
import * as actions from "../../../store/actions/crm";
import { formatDate } from "helpers/formatter";
import {
  CompanyAddUser,
  CompanyBaseInfo,
  CompanyPaymentInfo,
  CompanySubscription
} from "../forms";

const AddCompany = props => {
  const { history } = props;

  const {
    formState: { errors },
    setError,
    reset
  } = useForm();
  const dispatch = useDispatch();

  const {
    countries,
    countryDatasets,
    categories,
    selectedCompany,
    errors: responseErrors
  } = useSelector(state => state.crm);

  useEffect(() => {
    if (countries.length === 0) {
      API.crm.getCountries();
    }
    if (countryDatasets.length === 0) {
      API.crm.getCoutryDatasets();
    }
    if (categories.length === 0) {
      API.crm.getCategories();
    }

    return () => {
      dispatch(actions.removeCompanyInfo());
    };
  }, []);
  /* eslint-disable */

  useEffect(() => {
    reset();
    if (
      selectedCompany &&
      selectedCompany.paymentInfo &&
      selectedCompany?.subscription &&
      selectedCompany.members.length > 0
    ) {
      history.push(`${crm}/company/${selectedCompany.id}`);
    }
  }, [selectedCompany]);

  useEffect(() => {
    if (responseErrors) {
      Object.keys(responseErrors).forEach(key => {
        setError(key, {
          type: "manual",
          message:
            responseErrors[key] instanceof Array
              ? responseErrors[key].toString()
              : responseErrors[key]
        });
      });
    }
  }, [responseErrors]);

  const submitCreateCompany = data => {
    API.crm.createCompany({
      ...data,
      country: data?.country?.value
    });
  };

  const submitCreatePaymentInfo = data => {
    API.crm.createPaymentInfo({
      ...data,
      company: selectedCompany.id
    });
  };

  const submitCreateSubscription = data => {
    API.crm.createSubscription({
      additional_categories:
        data?.additional_categories?.map(({ item }) => item.id) || [],
      excluded_categories:
        data?.excluded_categories?.map(({ item }) => item.id) || [],
      country_datasets:
        data?.country_datasets?.map(({ item }) => item.id) || [],
      expiration_date: formatDate(data?.expiration_date, "YYYY-MM-DD"),
      company: selectedCompany?.id,
      subscription_type: data?.subscription_type?.value,
      download_data: data?.download_data,
      show_affinity_numbers: data?.show_affinity_numbers
    });
  };

  const submitAddUser = async user => {
    await API.crm.addCompanyUser(user, selectedCompany.id);
  };

  return (
    <Container id="audiences" fluid>
      <div className="audiences-background">
        <div className="background-light" />
      </div>
      <Container className="audiences-container">
        <Row>
          <Header />
        </Row>
        <Row>
          <Col xs={12}>
            <Card className={"w-100 p-4"}>
              <CardTitle className={"text-center w-100"}>
                Create Company
              </CardTitle>
              <CardBody>
                <Row className="g-3">
                  {selectedCompany ? (
                    <div></div>
                  ) : (
                    <Col sm={12}>
                      <CompanyBaseInfo
                        countries={countries}
                        onSubmit={submitCreateCompany}
                        errors={errors}
                        resetForm={reset}
                      />
                    </Col>
                  )}
                </Row>

                <Row className="g-3">
                  {selectedCompany && !selectedCompany.paymentInfo ? (
                    <Col sm={12}>
                      <h5>Payment info for {selectedCompany.name}</h5>
                      <CompanyPaymentInfo
                        onSubmit={submitCreatePaymentInfo}
                        errors={errors}
                        resetForm={reset}
                      />
                    </Col>
                  ) : (
                    <div></div>
                  )}
                </Row>
                <Row>
                  {selectedCompany &&
                  selectedCompany.paymentInfo &&
                  !selectedCompany?.subscription ? (
                    <Col sm={12}>
                      <h5 className="">
                        Now select subscription for {selectedCompany.name}
                      </h5>
                      <CompanySubscription
                        allCountryDatasets={countryDatasets}
                        onSubmit={submitCreateSubscription}
                        categories={categories}
                        resetForm={reset}
                      />
                    </Col>
                  ) : null}
                </Row>
                <Row>
                  {selectedCompany &&
                  selectedCompany.paymentInfo &&
                  selectedCompany?.subscription ? (
                    <Col xs={12}>
                      <CompanyAddUser
                        onSubmit={submitAddUser}
                        companyName={selectedCompany.name}
                        errors={errors}
                        resetForm={reset}
                      />
                    </Col>
                  ) : null}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default AddCompany;
